import { Box, Typography } from '@mui/material'
import React from 'react'

const ChartLegend: React.FC<{
  title: string
  color: string
  isLineThrough?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement>
}> = ({ title, color, isLineThrough, onClick }) => {
  return (
    <div className="tw-cursor-pointer tw-select-none" onClick={onClick}>
      <Box
        sx={{ backgroundColor: color }}
        className="tw-w-2 tw-h-2 tw-mr-2 tw-inline-block tw-rounded-full"
      />
      <Typography
        variant="body3"
        className={isLineThrough ? 'tw-line-through' : ''}
        component="span"
      >
        {title}
      </Typography>
    </div>
  )
}

export default ChartLegend
